import { render } from "./ApproveUser.vue?vue&type=template&id=60419ff5"
import script from "./ApproveUser.vue?vue&type=script&lang=js"
export * from "./ApproveUser.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__